import DefaultLayout from "../components/layout/DefaultLayout";
function ContactUsPage() {
  const body = () => {
    return (
      <div>
        <section className="slice sct-color-1">
          <div className="container relative">
            <div className="row">
              <div className="col-12">
                <div className="py-5 text-center">
                  <h1 className="heading heading-1 strong-400 text-normal">
                    Contactanos en cualquier momento.
                  </h1>

                  <span className="clearfix"></span>

                  <div className="fluid-paragraph fluid-paragraph-sm strong-300 text-center mt-1">
                    Encuentra la casa de tus sueños, con todas las comodidades
                    que buscabas y en el mejor lugar.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="slice pt-0 sct-color-1">
          <div className="container">
            <div className="row align-items-center cols-xs-space cols-sm-space cols-md-space">
              <div className="col-md-6">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.8404550273904!2d-75.61739504981078!3d6.152116629054488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e4683d9518b16b5%3A0x104da1f301afe6d6!2sArrendamientos%20la%20Casona%20Ltda.!5e0!3m2!1sen!2sco!4v1576685538443!5m2!1sen!2sco"
                  width="500"
                  height="400"
                  frameBorder="0"
                  style={{ border: "0" }}
                  allowFullScreen=""
                ></iframe>
              </div>

              <div className="col-md-6 col-lg-5 offset-lg-1">
                <div className="">
                  <h3 className="heading heading-3 strong-300">
                    Cra. 45 Sur 52 #68
                    <br />
                    Sabaneta, Antioquia
                  </h3>

                  <p className="lead mt-4 mb-4">
                    Email: <a href="#">soporte@arrendamientoslacasona.com</a>
                    <br />
                    Telefono: 318 296 2222
                  </p>

                  <p className="lead">
                    Nos puedes encontrar desde las 8 AM hasta las 6 PM. Siente
                    libre de crear una cita para conocer tu proximo hogar.
                    <br />O contactanos en nuestras redes sociales
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default ContactUsPage;
